/**
 * innvolo-base.js — utilidades compartidas por las secciones innvolo-*.
 *
 * Cero lógica de negocio (07-convenciones.md): esto solo anima.
 * El cálculo de precios vive en el backend propio, nunca aquí.
 */
(function () {
  'use strict';

  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /**
   * Revelado suave al entrar en pantalla.
   * El CSS solo oculta el elemento si esta clase está puesta, así que sin JS
   * (o sin IntersectionObserver) el contenido se ve igual. Nunca deja la
   * página en blanco.
   */
  function activarRevelado(raiz) {
    var nodos = (raiz || document).querySelectorAll('[data-innvolo-revela]');
    if (!nodos.length) return;

    if (sinMovimiento || !('IntersectionObserver' in window)) {
      nodos.forEach(function (n) {
        n.dataset.innvoloVisible = 'si';
      });
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.dataset.innvoloVisible = 'si';
          observador.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px' }
    );

    nodos.forEach(function (n) {
      n.classList.add('innvolo-revela--activo');
      observador.observe(n);
    });
  }

  activarRevelado(document);

  /* El editor de temas reinyecta secciones sin recargar la página. */
  document.addEventListener('shopify:section:load', function (e) {
    activarRevelado(e.target);
  });

  window.innvolo = window.innvolo || {};
  window.innvolo.sinMovimiento = sinMovimiento;
  window.innvolo.activarRevelado = activarRevelado;
})();
